export default __webpack_public_path__ + "static/media/ER10.d14bb6b1.png";